export default function HelpAndFAQ() {
  const containerStyle = {
    maxWidth: "800px",
    margin: "40px auto",
    fontFamily: "'Segoe UI', sans-serif",
  };

  const cardStyle = {
    backgroundColor: "#fff",
    padding: "30px",
    borderRadius: "10px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    marginBottom: "30px",
  };

  const headingStyle = {
    textAlign: "center",
    fontWeight: "600",
    fontSize: "28px",
    marginBottom: "20px",
  };

  const questionStyle = {
    fontWeight: "600",
    marginTop: "20px",
  };

  const answerStyle = {
    marginTop: "5px",
    lineHeight: "1.6",
  };

  const emailLinkStyle = {
    color: "#007bff",
    textDecoration: "none",
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <h2 style={headingStyle}>Need Help?</h2>
        <p style={{ textAlign: "center" }}>
          For any support inquiries, please reach out to us at:
          <br />
          <strong>Email:</strong>{" "}
          <a href="mailto:admin@adventuredating.com" style={emailLinkStyle}>
            admin@adventuredating.com
          </a>
        </p>
      </div>

      <div style={cardStyle}>
        <h3 style={{ fontWeight: "600", marginBottom: "20px" }}>
          Frequently Asked Questions
        </h3>

        <p style={questionStyle}>Q: What is the Adventure Dating app?</p>
        <p style={answerStyle}>
          A: Adventure Dating is a unique matchmaking app designed for people
          who love outdoor activities, travel, and thrilling experiences. It
          helps you meet like-minded adventurers nearby or around the world.
        </p>

        <p style={questionStyle}>Q: How do I find matches?</p>
        <p style={answerStyle}>
          A: Simply set your preferences, and the app will suggest potential
          matches who share your love for adventure. You can swipe, connect, and
          plan your next journey together.
        </p>

        <p style={questionStyle}>
          Q: Is it safe to meet someone through the app?
        </p>
        <p style={answerStyle}>
          A: Your safety is our priority. We encourage users to verify their
          profiles and follow our safety guidelines when meeting in person.
        </p>

        <p style={questionStyle}>
          Q: Will I get notifications for events or trips near me?
        </p>
        <p style={answerStyle}>
          A: Yes, you’ll receive real-time updates and event notifications based
          on your interests and location.
        </p>
      </div>
    </div>
  );
}
